export function handleStepPriceUpdated(state, patch) {
    const {type, payload} = patch
    const q = state.quantitiesById[payload.qdId];

    if (!q) {
        return state;
    }

    const key =
        payload.priceType === 1
            ? "buy_step"
            : "sell_step";

    return {
        ...state,
        quantitiesById: {
            ...state.quantitiesById,
            [payload.qdId]: {
                ...q,
                [key]: payload.step,
            },
        },
    };
}